import { render, staticRenderFns } from "./LogisticsModul.vue?vue&type=template&id=de8339e4&scoped=true&"
import script from "./LogisticsModul.vue?vue&type=script&lang=js&"
export * from "./LogisticsModul.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsModul.vue?vue&type=style&index=0&id=de8339e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8339e4",
  null
  
)

export default component.exports